/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CorrectTicketStatusDto } from '../../models/correct-ticket-status-dto';
import { TicketItem } from '../../models/ticket-item';

export interface TicketControllerCorrectTicketStatus$Params {
  id: number;
      body: CorrectTicketStatusDto
}

export function ticketControllerCorrectTicketStatus(http: HttpClient, rootUrl: string, params: TicketControllerCorrectTicketStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerCorrectTicketStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketItem;
      }>;
    })
  );
}

ticketControllerCorrectTicketStatus.PATH = '/ticket/correct-ticket-status/{id}';
